import { Empty } from 'antd';

import {
  HealthDependency,
  HealthGroup,
} from '../../services/integrationHealthApi';
import { DependencyCard } from './DependencyCard';

export function GroupCards(props: {
  group?: HealthGroup;
  onOpenLogs: (dependency: HealthDependency) => void;
  onCheck: (serviceKey: string) => void;
  // Um conjunto, não uma chave: verificar o PSP (20s) e clicar no Portal Único
  // fazia o spinner do PSP parar, e o finally do primeiro apagava o do segundo.
  checkingKeys: Set<string>;
}) {
  const { group, onOpenLogs, onCheck, checkingKeys } = props;

  if (!group || group.dependencies.length === 0) {
    return <Empty description="Nenhuma integração neste grupo." />;
  }

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: 14,
        padding: '20px 24px 48px',
      }}
    >
      {group.dependencies.map((dependency) => (
        <DependencyCard
          key={dependency.key}
          dependency={dependency}
          onOpenLogs={onOpenLogs}
          onCheck={onCheck}
          isChecking={checkingKeys.has(dependency.key)}
        />
      ))}
    </div>
  );
}
